import { useContext, useMemo } from "react";
import { LocaleContext } from "../LocaleProvider";
import { RelativeTimeFormat, RelativeTimeFormatOptions } from "../@utils";

export interface RelativeTimeProps extends RelativeTimeFormatOptions {
  children?: never;
  className?: string;
  /**
   * Numeric value to use in the internationalized relative time message.
   */
  value: number;
  /**
   * Unit to use in the relative time internationalized message
   */
  unit:
    | "year"
    | "quarter"
    | "month"
    | "week"
    | "day"
    | "hour"
    | "minute"
    | "second";
}

export const RelativeTime = ({
  value,
  unit,
  className,
  ...options
}: RelativeTimeProps) => {
  const locale = useContext(LocaleContext);
  const label = useMemo(
    () => RelativeTimeFormat(locale, options).format(value, unit),
    [value, locale, options, unit],
  );
  return <span className={className}>{label}</span>;
};
